import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { ApiErrorDetails } from 'app/shared/models/api-error';

export interface ErrorDialogData {
  title?: string;
  message?: string;
  details?: ApiErrorDetails;
  showDetails?: boolean;
}

@Component({
  selector: 'app-error-dialog',
  imports: [MatButtonModule, MatDialogModule, MatExpansionModule, MatIconModule],
  templateUrl: './error-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ErrorDialogComponent>);
  protected readonly data = inject<ErrorDialogData>(MAT_DIALOG_DATA);

  protected onClose(): void {
    this.dialogRef.close();
  }

  protected getDefaultTitle(): string {
    if (this.data.details?.statusCode) {
      return `Fehler ${this.data.details.statusCode}`;
    }
    return 'Ein Fehler ist aufgetreten';
  }

  protected getDefaultMessage(): string {
    return (
      this.data.message ||
      'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.'
    );
  }
}
